import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import ua from "./ua.svg";
import ru from "./ru.svg";
import "./LanguageSelector.css";

let countries = [
  {
    value: "ua",
    label: ua,
    country_code: "ua",
  },
  {
    value: "ru",
    label: ru,
    country_code: "ru",
  },
];

export const Namespaces = {
  login: "login",
  awards: "awards",
  awardInfo: "awardInfo",
  profile: "profile",
  welcome: "welcome",
  rollerLevel: "rollerLevel",
  achievement: "achievement",
};

export const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChange = useCallback((value) => {
    i18n.changeLanguage(value);
  }, [i18n]);

  const selectOptions = useMemo(() => countries.map((country) => ({
    ...country,
    label: (
      <img
        className="languageIcon"
        src={country.label}
        alt={country.country_code}
      />
    ),
  })), []);

  return (
    <Select
      options={selectOptions}
      className="selectUI"
      defaultValue={i18n.language}
      style={{ width: 80, height: 40 }}
      onChange={handleChange}
      variant='borderless'
    />
  );
};
